module.exports = __webpack_public_path__ + "img/photograph.d4cc8fb0.svg";